import React from "react";
import Table from "react-bootstrap/Table";
import moment from "moment";
import { ChatScreenTrack } from "../../../superAdminComponents/superAdminAllComponent/superAdminOpenIssuesUsers/ViewUsersTickets/ChatScreenTrack";

import isEmpty from "../../../../store/validation/is-Empty";

export const RightIssuesSuggestion = ({
  tableBody,
  sendDataProps,
  displayChatScreen,
  displayInput,
  displayChatScreenFunc,
  onComment,
  onChange,
  commentValue,
  onClickChatButton,
  comment,
}) => {
  return (
    <React.Fragment>
      <div className="open_issues_view_tickets_right">
        <div className="col-12 mt-4 p-0 audit-log-table">
          <div className="col-12 open_issues_view_tickets_right_inside d-flex align-items-center justify-content-between">
            <h3>
              {displayChatScreen === false ? (
                ""
              ) : (
                <i
                  className="fa fa-long-arrow-left"
                  aria-hidden="true"
                  onClick={displayChatScreenFunc}
                ></i>
              )}
              &nbsp; Resolution Log
            </h3>
            {displayChatScreen === true ? (
              ""
            ) : (
              <button
                className="resolution_button_text"
                onClick={displayChatScreenFunc}
              >
                View All
              </button>
            )}
          </div>
          {displayChatScreen === false ? (
            <div className="open_issues_view_tickets_right_inside">
              <Table>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Comment</th>
                    <th>By</th>
                  </tr>
                </thead>
                <tbody>{tableBody}</tbody>
              </Table>
            </div>
          ) : (
            <div className="col-12 open_issues_view_tickets_chat_screen">
              <div className="display-chat-screen-one">
                <div>
                  <h3>{sendDataProps.seating_request_no}</h3>
                  <p className="bottom-text color-gray">Request Number</p>
                </div>
                <div className="status-chat-screen">
                  <h3 className="bottom-text color-white">
                    {sendDataProps.status === 0
                      ? "New"
                      : sendDataProps.status === 1
                      ? "In-Progress"
                      : sendDataProps.status === 2
                      ? "Awaiting - Feedback"
                      : sendDataProps.status === 3
                      ? "On-Hold"
                      : sendDataProps.status === 4
                      ? "ReOpened"
                      : sendDataProps.status === 5
                      ? "Resolved"
                      : sendDataProps.status === 6
                      ? "Closed"
                      : sendDataProps.status === 7
                      ? "Archive"
                      : sendDataProps.status === 8
                      ? "Called User"
                      : sendDataProps.status === 9
                      ? "Completed"
                      : ""}
                  </h3>
                </div>
              </div>
              <div className="chat-screen-max-height" id="style-4">
                {!isEmpty(comment) &&
                  comment.map((singleChat, index) => {
                    return (
                      <React.Fragment key={index}>
                        <ChatScreenTrack
                          chatParagraph={singleChat.content}
                          chatDate={moment(singleChat.time).format(
                            "hh:mm A, Do MMMM YYYY"
                          )}
                          messageBy={sendDataProps.vendor_id._id}
                          senderId={singleChat.comment_initiator_id}
                          chatBy={
                            sendDataProps.vendor_id._id ===
                            singleChat.comment_initiator_id
                              ? "You"
                              : "Admin"
                          }
                        />
                      </React.Fragment>
                    );
                  })}
              </div>
            </div>
          )}
        </div>
        {displayChatScreen === false ? (
          ""
        ) : displayInput ? (
          <div className="chat-submit-button">
            <div>
              <div className="input-group button-chat-box">
                <input
                  type="text"
                  className="form-control input-box-height"
                  placeholder="Write your comment"
                  aria-label="Write your comment"
                  aria-describedby="button-addon2"
                  onChange={onChange}
                  name={onComment}
                  value={commentValue}
                />
                <div className="input-group-append chat-button-box">
                  <button
                    className="chat-button-box-button"
                    type="button"
                    id="button-addon2"
                    onClick={onClickChatButton}
                  >
                    <i
                      className="font-awesome-flag-size fa fa-paper-plane"
                      aria-hidden="true"
                    ></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </div>
    </React.Fragment>
  );
};
